import * as React from "react";
import { CompetitiveAnalysisDetailT } from "../types";
import MainContainer from "./partials/MainContainer";

export default ({ data }: CompetitiveAnalysisDetailT): JSX.Element => {
  return <MainContainer competitiveAnalysis={data} />;
};
